<template>
  <div style="min-width: 500px">
    <h1 class="grey--text text--darken-2">Профиль</h1>

    <v-form ref="form" autocomplete="off">
        <v-text-field
          type="password"
          v-model.trim="form.password"
          :error-messages="verrpassword"
          autofocus
          prepend-icon="mdi-key"
          hint="Текущий пароль"
          persistent-hint
        />

        <v-text-field
          type="password"
          v-model.trim="form.newPassword1"
          :error-messages="verrNewPassword1"
          prepend-icon="mdi-key"
          hint="Новый пароль"
          persistent-hint
        />

        <v-text-field
          type="password"
          v-model.trim="form.newPassword2"
          :error-messages="verrNewPassword2"
          prepend-icon="mdi-key"
          hint="Новый пароль (повторите)"
          persistent-hint
        />

      <v-divider class="mt-10"/>
      <v-card-actions class="mt-1">
        <v-btn
          raised
          @click="cancelAction" class="mr-3">Отмена</v-btn>
        <v-btn
          raised
          color="primary"
          :loading="loading"
          :disabled="$v.$invalid"
          @click="submitAction">Сохранить</v-btn>
      </v-card-actions>

    </v-form>

  </div>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { requiredIf, sameAs, minLength } from 'vuelidate/lib/validators'
  import api from '@/api'

  export default {
    mixins: [ validationMixin ],
    data: () => ({
      loading: false,
      form: {},
    }),
    validations: {
      form: {
        password: {
          required: requiredIf('newPassword1')
        },
        newPassword1: {
          minLength: minLength(6),
          sameAsPassword: sameAs('newPassword2')
        },
        newPassword2: {
          sameAsPassword: sameAs('newPassword1')
        }
      }
    },
    computed: {
      verrpassword () {
        return !this.$v.form.password.required ? 'Введите текущий пароль' : []
      },
      verrNewPassword1 () {
        return !this.$v.form.newPassword1.minLength ? 'Минимум 6 символов' :
          !this.$v.form.newPassword1.sameAsPassword ? 'Пароли должны совпадать' : []
      },
      verrNewPassword2 () {
        return !this.$v.form.newPassword2.sameAsPassword ? 'Пароли должны совпадать' : []
      },
    },
    methods: {
      cancelAction () {
        this.$refs.form.reset()
      },
      submitAction () {
        if ( this.$v.$error ) return
        this.loading = true
        api.post('account/update', this.form).then(response => {
          this.loading = false;
          if ( response.data.result !== 'ok' ) return this.$root.$alert(response.data.data, true)
          if ( response.data.data.affected ) this.$root.$alert('Учетная запись изменена')
          this.password = this.newPassword1 = this.newPassword2 = ''
        }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
      }
    },
  }

</script>
